import React from "react";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";
const MaintenanceDetailModal = ({ show, onHide, maintenance }) => {
  if (!maintenance) return null;
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("DD-MM-YYYY");
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Vehicle Maintenance Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Vehicle NumberPlate:</strong>{" "}
          {maintenance.vehicle ? maintenance.vehicle.numberplate : "-"}
        </p>
        <p>
          <strong>Vehicle Status:</strong>{" "}
          {maintenance.vehicle ? maintenance.vehicle.status : "-"}
        </p>
        <p>
          <strong>Last Service Date: </strong>{" "}
          {formatDate(maintenance.lastServiceDate)}
        </p>
        <p>
          <strong>Last Service Km:</strong> {maintenance.lastServiceKm}
        </p>

        <p>
          <strong>Next Service Date: </strong>{" "}
          {formatDate(maintenance.nextServiceDueDate)}
        </p>
        <p>
          <strong>Next Service Km:</strong> {maintenance.nextServiceDueKm}
        </p>

        <p>
          <strong>Status:</strong> {maintenance.status}
        </p>
        <p>
          <strong>Notes:</strong> {maintenance.notes}
        </p>
        <p>
          <strong>Created Date:</strong>{" "}
          {maintenance.createdAt && (
            <>{new Date(maintenance.createdAt).toLocaleDateString()}</>
          )}
        </p>

        <p>
          <strong>Updated Date:</strong>{" "}
          {maintenance.updatedAt && (
            <>{new Date(maintenance.updatedAt).toLocaleDateString()}</>
          )}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MaintenanceDetailModal;
